module.exports = __webpack_public_path__ + "media/application/images/svgs/facebook-dark-8fd73e4e7daa0de9ecc2631939f99c92.svg";